// Material UI
import { darken, lighten } from "@mui/material/styles";

// Constants
import { boxShadow } from "Constants/ColourConstants";
import { BUTTON_BORDER_RADIUS } from "Constants/theme";

export const styles = {
  dialogPaper: (statusVariant) => (theme) => {
    const isDarkMode = theme.palette.mode === "dark";
    const getStatusSurface = () => {
      if (statusVariant === "success") {
        return isDarkMode
          ? darken(theme.palette.success.main, 0.72)
          : lighten(theme.palette.success.main, 0.88);
      }
      if (statusVariant === "error") {
        return isDarkMode
          ? darken(theme.palette.error.main, 0.72)
          : lighten(theme.palette.error.main, 0.88);
      }

      return theme.palette.background.paper;
    };

    return {
      width: "100%",
      m: 2,
      p: { xs: 2, sm: 3 },
      borderRadius: BUTTON_BORDER_RADIUS,
      boxShadow,
      backgroundColor: getStatusSurface(),
    };
  },
  title: {
    width: "100%",
    textAlign: "left",
    fontSize: { xs: "1.1rem", sm: "1.3rem" },
    fontWeight: 550,
    lineHeight: 1.2,
  },
  patientName: {
    fontWeight: 700,
    fontSize: { xs: "1.05rem", sm: "1.25rem" },
    minWidth: 0,
    overflowWrap: "anywhere",
    wordBreak: "break-word",
  },
  detailIcon: {
    color: "secondary.main",
    fontSize: { xs: "1.25rem", sm: "1.5rem" },
    flexShrink: 0,
  },
  detailText: {
    fontSize: { xs: "0.95rem", sm: "1rem" },
    lineHeight: 1.3,
  },
  supportingText: {
    fontSize: { xs: "0.7rem", sm: "0.75rem" },
    lineHeight: 1.25,
  },
  clinicMessage: {
    width: "100%",
    pt: 0.25,
  },
  actions: {
    pt: 1,
    alignItems: "center",
    justifyContent: "flex-end",
  },
  detailsColumn: {
    flex: 1,
    minWidth: 0,
  },
  dateCard: {
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    p: { xs: 1.5, sm: 2 },
    border: 1,
    borderColor: "divider",
    borderRadius: BUTTON_BORDER_RADIUS,
    width: { xs: 110, sm: "auto" },
    minWidth: { xs: 110, sm: 156 },
    alignSelf: "flex-start",
    flexShrink: 0,
  },
  dateLabel: {
    fontSize: { xs: "0.9rem", sm: "1.125rem" },
    fontWeight: 600,
    lineHeight: 1.33,
    color: "text.secondary",
  },
  day: {
    fontSize: { xs: "2.25rem", sm: "4rem" },
    fontWeight: 500,
    lineHeight: 0.9,
    color: "text.primary",
  },
  month: {
    fontSize: { xs: "0.9rem", sm: "1.125rem" },
    fontWeight: 600,
    lineHeight: 1.33,
    color: "text.primary",
  },
  time: {
    fontSize: { xs: "0.95rem", sm: "1.25rem" },
    fontWeight: 600,
    lineHeight: 1.2,
    color: "text.primary",
  },
};
